import { render, staticRenderFns } from "./SchedulePickup.vue?vue&type=template&id=c8a80b72"
import script from "./SchedulePickup.vue?vue&type=script&lang=js"
export * from "./SchedulePickup.vue?vue&type=script&lang=js"
import style0 from "./SchedulePickup.vue?vue&type=style&index=0&id=c8a80b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports